import { render, staticRenderFns } from "./BreathingGame.vue?vue&type=template&id=13b6a6ee&scoped=true&"
import script from "./BreathingGame.vue?vue&type=script&lang=js&"
export * from "./BreathingGame.vue?vue&type=script&lang=js&"
import style0 from "./BreathingGame.vue?vue&type=style&index=0&id=13b6a6ee&scoped=true&lang=scss&"
import style1 from "./BreathingGame.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b6a6ee",
  null
  
)

export default component.exports